export const Price = [
  { code: "-1", name: "No Preference" },
  { code: "2000", name: "$2,000" },
  { code: "5000", name: "$5,000" },
  { code: "34999", name: "$34,999" },
  { code: "35000", name: "$35,000" },
  { code: "100000", name: "$100,000" },
  { code: "105000", name: "$105,000" },
  { code: "125000", name: "$125,000" },
  { code: "150000", name: "$150,000" },
  { code: "175000", name: "$175,000" },
  { code: "185000", name: "$185,000" },
  { code: "200000", name: "$200,000" },
  { code: "225000", name: "$225,000" },
  { code: "250000", name: "$250,000" },
  { code: "275000", name: "$275,000" },
  { code: "300000", name: "$300,000" },
  { code: "325000", name: "$325,000" },
  { code: "350000", name: "$350,000" },
  { code: "375000", name: "$375,000" },
  { code: "400000", name: "$400,000" },
  { code: "450000", name: "$450,000" },
  { code: "475000", name: "$475,000" },
  { code: "500000", name: "$500,000" },
  { code: "550000", name: "$550,000" },
  { code: "600000", name: "$600,000" },
  { code: "650000", name: "$650,000" },
  { code: "700000", name: "$700,000" },
  { code: "750000", name: "$750,000" },
  { code: "800000", name: "$800,000" },
  { code: "850000", name: "$850,000" },
  { code: "900000", name: "$900,000" },
  { code: "950000", name: "$950,000" },
  { code: "1000000", name: "$1M" },
  { code: "1100000", name: "$1.1M" },
  { code: "1200000", name: "$1.2M" },
  { code: "1300000", name: "$1.3M" },
  { code: "1400000", name: "$1.4M" },
  { code: "1500000", name: "$1.5M" },
  { code: "2000000", name: "$2M" },
  { code: "2500000", name: "$2.5M" },
  { code: "3000000", name: "$3M" },
  { code: "3500000", name: "$3.5M" },
  { code: "4000000", name: "$4M" },
  { code: "4500000", name: "$4.5M" },
  { code: "5000000", name: "$5M" },
  { code: "6000000", name: "$6M" },
  { code: "7000000", name: "$7M" },
  { code: "8000000", name: "$8M" },
  { code: "9000000", name: "$9M" },
  { code: "10000000", name: "$10M" },
];

// For Min dropdown
export const minPriceOptions = [
  { ...Price[0], name: "Min" },
  ...Price.slice(1)
];

// For Max dropdown
export const maxPriceOptions = [
  { ...Price[0], name: "Max" },
  ...Price.slice(1)
];

export const Beds = [
   { code: "-1", name: "Beds" },
  { code: "1", name: "1+" },
  { code: "2", name: "2+" },
  { code: "3", name: "3+" },
  { code: "4", name: "4+" },
  { code: "5", name: "5+" },
  { code: "6", name: "6+" },
  { code: "7", name: "7+" },
  { code: "8", name: "8+" },
  { code: "9", name: "9+" },
  { code: "10", name: "10+" },
];

export const Baths = [
   { code: "-1", name: "Baths" },
  { code: "1", name: "1+" },
  { code: "1.5", name: "1.5+" },
  { code: "2", name: "2+" },
  { code: "2.5", name: "2.5+" },
  { code: "3", name: "3+" },
  { code: "3.5", name: "3.5+" },
  { code: "4", name: "4+" },
  { code: "4.5", name: "4.5+" },
  { code: "5", name: "5+" },
  { code: "5.5", name: "5.5+" },
  { code: "6", name: "6+" },
  { code: "6.5", name: "6.5+" },
  { code: "7", name: "7+" },
  { code: "7.5", name: "7.5+" },
  { code: "8", name: "8+" },
  { code: "8.5", name: "8.5+" },
  { code: "9", name: "9+" },
  { code: "9.5", name: "9.5+" },
  { code: "10", name: "10+" },
];

export const LotSize = [
   { code: "-1", name: "No Preference" },
  { code: "0", name: "0 Sqft.+" },
  { code: "0.06", name: "2500 Sqft.+" },
  { code: "0.11", name: "5000 Sqft.+" },
  { code: "0.17", name: "7500 Sqft.+" },
  { code: "0.23", name: "10000 Sqft.+" },
  { code: "0.34", name: "15000 Sqft.+" },
  { code: "0.46", name: "20000 Sqft.+" },
  { code: "0.69", name: "30000 Sqft.+" },
  { code: "0.92", name: "40000 Sqft.+" },
  { code: "1", name: "1 Acres+" },
  { code: "2", name: "2 Acres+" },
  { code: "3", name: "3 Acres+" },
  { code: "4", name: "4 Acres+" },
  { code: "5", name: "5 Acres+" },
  { code: "10", name: "10 Acres+" },
];

export const propertystatus = [
  { code: "-1", name: "No Preference" },
  { code: "0", name: "Active" },
  { code: "1", name: "Under Contract" },
];

export const eitheroroptions = [
  { code: "-1", name: "No Preference" },
  { code: "1", name: "Yes" },
  { code: "2", name: "No" },
];

export const sortoptions =[
  { code: "2", name: "Price Low to High" }, 
  { code: "1", name: "Price High to Low" },
  { code: "7", name: "Days on Site - New To Old" },
  { code: "8", name: "Days on Site - Old To New" }
]
export const megaMenuImages = [
  "../assets/image/header/mega-menu/mega-menu-img-1.png",
];